module.exports = __webpack_public_path__ + "media/fonts/Oricons-96ae136c9157a83a6ff1a1d746475964.eot";